import computeCashMoodPoints from "./compute_cash_mood_points";

export const processChangeGameChoices = (eventType, beforeGameData, eventObj) => {
    let subProcess = "";
    if (eventType === "UnlockedFeatures"){
        subProcess = eventObj.unlockedFeature;
    }else{
        subProcess = eventObj.changeMade;
    }
    const title = eventObj.changeMade + " changed - new choice is: " + eventObj.new;
    let returnTable = [];
    let assetTotal = 0;
    let expenseTotal = 0;
    let loanTotal = 0;
    for (let i=0; i<eventObj.assetTable.length; i++){
        const asset = eventObj.assetTable[i];
        if (asset.assetNbrMonths !== 0){
            assetTotal = +assetTotal + +eventObj.assetTable[i].assetAmt; 
        }
    }
    assetTotal = assetTotal.toFixed(2);
    const assetObj = {tableType: "asset", newTableTotal: assetTotal, process: "ChangeGameChoices",
        subProcess: title};
    returnTable.push(assetObj);
    for (let i=0; i<eventObj.expenseTable.length; i++){
        const expense = eventObj.expenseTable[i];
        if (expense.expNbrMonths !== 0 ){
            expenseTotal = +expenseTotal + +eventObj.expenseTable[i].expAmount;
        }
    }
    expenseTotal = expenseTotal.toFixed(2);
    const expenseObj = {tableType: "expense", newTableTotal: expenseTotal, process: "ChangeGameChoices",
        subProcess: title};
    returnTable.push(expenseObj);
    for (let i=0; i<eventObj.loanTable.length; i++){
        const loan = eventObj.loanTable[i];
        if (loan.loanNbrMonths !== 0 ){
            loanTotal = +loanTotal + +eventObj.loanTable[i].loanAmt;
        }
    }
    loanTotal = loanTotal.toFixed(2);
    const loanObj = {tableType: "loan", newTableTotal: loanTotal, process: "ChangeGameChoices",
        subProcess: title};
    returnTable.push(loanObj);
   
    const afterCashMoodObj = computeCashMoodPoints(eventType, beforeGameData.beforeCash, eventObj.cashChg,
        beforeGameData.beforeMoodPoints, eventObj.moodPoints, subProcess);
    returnTable.push(afterCashMoodObj);

    return returnTable;
}

export default processChangeGameChoices;